export default __webpack_public_path__ + "static/media/Bungie_Logo_black_background.abfa3507.png";